import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function PrivateRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <div className="admin-loading">Loading...</div>;
  }

  return isAuthenticated ? children : <Navigate to="/admin/login" replace />;
}
